export default function OrderHistoryHeaderList({ isOpenOrder, isAllOrder }) {
  return (
    <>
      <th className="table-list-cell align-left">Market</th>
      <th className="table-list-cell align-left">Type</th>
      <th className="table-list-cell align-left">Side</th>
      <th className="table-list-cell align-left">Order price</th>
      {isOpenOrder ? (
        <>
          <th className="table-list-cell align-left">Filled size</th>
          <th className="table-list-cell align-left">Order size</th>
        </>
      ) : (
        <>
          <th className="table-list-cell align-left">Filled price</th>
          <th className="table-list-cell align-left">Order size</th>
          <th className="table-list-cell align-left">Filled size</th>
        </>
      )}
      <th className="table-list-cell align-left">Value</th>
      <th className="table-list-cell align-left">Fee</th>
      {isAllOrder && <th className="table-list-cell align-left">Status</th>}
      <th className="table-list-cell align-left">Order ID</th>
      <th className="table-list-cell align-left">Post Only</th>
      <th className="table-list-cell align-left">Reduce Only</th>
      <th className="table-list-cell align-left">Hidden</th>
      <th className="table-list-cell align-right">Time</th>
    </>
  )
}
